import React, { Component } from 'react';
import { Helmet } from 'react-helmet';

import classnames from 'classnames';
import { NavLink } from 'react-router-dom';

import { Modal } from 'components/modal/Modal';
import { GlamboxEndpoints } from '../../core/glambox/GlamboxEndpoints';
import { ExecuteRequest } from '../../core/glambox/GlamboxApi';

import { Container } from 'components/grid/Container';
import { Row } from 'components/grid/Row';
import { Col } from 'components/grid/Col';

import { connect } from 'react-redux';

import homeItens from 'assets/data/home.json';
import hashTagCampaigns from 'assets/data/hashTagCampaigns.json';
import cursosOnline from 'assets/data/cursos/index.json';

import {
  PossibleSubscriberIds,
  IsOrWasSubscriber,
  FilterSubscriberByEditions,
} from 'core/utils/SubscriberUtils';

import { YouTubeSubscribe } from 'components/home/YouTubeSubscribe';

class Home extends Component {
  constructor(props) {
    super(props);

    this.state = {
      rewardData: [],
      currentGlamclub: 0,
      currentEdition: 0,
      currentWinGlampoints: 0,
      currentCommunity: 0,
      currentGlamshop: 0,
      currentGlamgirl: 0,
      currentEducation: 0,
      currentVideoGlamTV: 0,
      currentVideoGlamTVIndex: 0,
      listVideosYoutube: [],
      glamTVThumbnail: '',
      products: [],
    };

    this._moveStatus = this._moveStatus.bind(this);
    this.renderPrevButton = this.renderPrevButton.bind(this);
    this.renderNextButton = this.renderNextButton.bind(this);
    this.glampointsReturn = this.glampointsReturn.bind(this);

    this.getGlampointsCreditHistory =
      this.getGlampointsCreditHistory.bind(this);
    this.toggleShippingModal = this.toggleShippingModal.bind(this);

    this.getProducts = this.getProducts.bind(this);
  }

  toggleShippingModal() {
    this.setState({
      shippingModalVisible: !this.state.shippingModalVisible,
    });
  }

  componentDidMount() {
    const { person, location, history, editions, subscribers } = this.props;

    if (Array.isArray(subscribers) && subscribers.length === 0) {
      history.push('/beneficios');
    }

    // Não é, nem foi, subscriber, go Benefícios
    if (
      person.person &&
      !IsOrWasSubscriber(person.person.personStatus) &&
      person.subs.length < 1
    ) {
      history.push('/beneficios');
    }

    this.setState({ rewardData: this.props.rewards });

    this.getYoutubeVideosFromPlaylist();

    this.getProducts();
  }

  getYoutubeVideosFromPlaylist() {
    //const CHANELID = "UCTTbhj9byYYGmek19EIDFrQ";
    const APIKEY = 'AIzaSyCu1_GWVB9aHYZHGNAnNO2hk2wr_ruSNLk';
    const PLAYLISTID = 'PLLDqrANGYQinFW2E1Mxthdbq6NK3JUtiV';
    const PARTS = 'part=contentDetails&part=snippet';
    const MAXRESULTS = 50;

    fetch(
      `https://youtube.googleapis.com/youtube/v3/playlistItems?${PARTS}&maxResults=${MAXRESULTS}&playlistId=${PLAYLISTID}&key=${APIKEY}`
    )
      .then(res => res.json())
      .then(data => {
        this.setState({
          currentVideoGlamTV: data.items[0].contentDetails.videoId,
          listVideosYoutube: data.items,
          // glamTVThumbnail: data.items[0].snippet.thumbnails.standard.url,
        });
      }, [])
      .catch(err => {
        console.log(err);
      });
  }

  getProducts() {
    ExecuteRequest(
      GlamboxEndpoints.GlamClub.listStorefront,
      {
        page: 0,
        pageSize: 250,
        searchKey: '',
      },
      'GET',
      {
        Authorization: this.props.token.Authorization,
      },
      null,
      response => {
        let { result, statusCode } = response;

        if (statusCode === 200) {
          this.setState({
            products: result.content.slice(0, 5),
          });
        }
      }
    );
  }

  getGlampointsCreditHistory() {
    ExecuteRequest(
      GlamboxEndpoints.Person.reward,
      null,
      'GET',
      {
        Authorization: this.props.token.Authorization,
      },
      null,
      response => {
        let { result, statusCode } = response;

        if (statusCode === 200) {
          this.setState({ rewardData: result });
        }
      }
    );
  }

  personStatus = () => {
    let { person } = this.props;
    let { personStatus } = person.person;

    return personStatus;
  };

  glampointsReturn(str) {
    let glampoints = 0;
    let points = str;

    for (let i = 0; i < points.length; i++) {
      glampoints += points[i].points;
    }

    return str;
  }

  statusEditionTracking = editionStatusId => {
    let status = 0;
    switch (editionStatusId) {
      case 0:
      case 1:
        status = 1;
        break;
      case 2:
      case 3:
        status = 2;
        break;
      case 4:
        status = 3;
        break;
      case 5:
        status = 4;
        break;
      case 6:
        status = 5;
        break;
      default:
        status = 0;
        break;
    }
    return (
      <div className={'box-status__progress'}>
        <div
          className={classnames('box-status__progress-bar', `status-${status}`)}
        >
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
    );

    //return status;
  };

  _moveStatus = (direction, curr, item, itemSet) => {
    let limit = item.length - direction;
    let moveTo = curr + direction;
    let direc =
      direction > 0
        ? moveTo > limit
          ? 0
          : moveTo
        : moveTo < 0
        ? item.length - 1
        : moveTo;

    this.setState({
      [itemSet]: direc,
    });
  };

  renderPrevButton = (curr, item, itemSet) => {
    let color = '#edf0f5';
    let direction = -1;
    if (itemSet === 'currentEdition') {
      direction = 1;
    }
    return (
      <button onClick={() => this._moveStatus(direction, curr, item, itemSet)}>
        <svg width="6.678" height="11.012" viewBox="0 0 6.678 11.012">
          <path
            d="M14.369,11.011a1.364,1.364,0,0,0,.989-2.3L12.305,5.5l3.05-3.188A1.365,1.365,0,1,0,13.383.421L9.433,4.549a1.365,1.365,0,0,0,0,1.884l3.949,4.154A1.364,1.364,0,0,0,14.369,11.011Z"
            transform="translate(-9.055 0)"
            fill={color}
          />
        </svg>
      </button>
    );
  };

  renderNextButton = (curr, item, itemSet) => {
    let color = '#edf0f5';
    let direction = 1;
    if (itemSet === 'currentEdition') {
      direction = -1;
    }
    return (
      <button onClick={() => this._moveStatus(direction, curr, item, itemSet)}>
        <svg width="6.678" height="11.012" viewBox="0 0 6.678 11.012">
          <path
            d="M10.419,11.011a1.364,1.364,0,0,1-.989-2.3L12.483,5.5,9.434,2.308A1.365,1.365,0,1,1,11.406.421l3.949,4.128a1.365,1.365,0,0,1,0,1.884l-3.949,4.154A1.364,1.364,0,0,1,10.419,11.011Z"
            transform="translate(-9.055 0)"
            fill={color}
          />
        </svg>
      </button>
    );
  };

  renderControllerButtons = (curr, item, itemSet) => {
    return (
      <div className={'control'}>
        {this.renderPrevButton(curr, item, itemSet)}
        {this.renderNextButton(curr, item, itemSet)}
      </div>
    );
  };

  renderBoxesEditions = Editions => {
    return Editions.map((item, key) => {
      return (
        <div
          key={key}
          className={this.state.currentEdition === key ? 'active' : 'noActive'}
        >
          <img
            src={`https://s3.amazonaws.com/Glambox.Content.MediaObject/Edition/${item.editionId}_boxEdition.png`}
            alt={''}
          />
          <p>{item.theme}</p>
          <h4 className={'statusEditionTrack'}>
            {this._currentStatusTitle(item.editionStatusId)}
          </h4>
          {this.statusEditionTracking(item.editionStatusId)}
          {this.renderControllerButtons(
            this.state.currentEdition,
            Editions,
            'currentEdition'
          )}
        </div>
      );
    });
  };

  _currentStatusTitle = editionStatusId => {
    switch (editionStatusId) {
      case 0:
      case 1:
        return 'Confirmado';
      case 2:
      case 3:
        return 'Montagem';
      case 4:
        return 'Retirada';
      case 5:
        return 'Em Rota';
      case 6:
        return 'Entregue';
      default:
        return 'Desconhecido';
    }
  };

  renderEditions = () => {
    const Editions = this.props.editions.slice(0, 12);

    if (this.personStatus() === 4 || this.personStatus() === 14) {
      return (
        <>
          <h3>Sua Caixa</h3>
          <span></span>
          {this.renderBoxesEditions(Editions)}
          <p>
            Confira as outras edições{' '}
            <NavLink to={'/edicoes'} className={'link'}>
              aqui
            </NavLink>
          </p>
        </>
      );
    } else {
      return <div>Assinar</div>;
    }
  };

  friendlyUrl = url => {
    return url
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '-')
      .replace(/^-+|-+$/g, '');
  };

  renderGlamclub = () => {
    const { products } = this.state;

    return products.map((item, key) => {
      return (
        <div
          key={key}
          className={this.state.currentGlamclub === key ? 'active' : 'noActive'}
        >
          <p>{item.name}</p>
          <NavLink
            to={`/produtos/${item.productId}/${
              item.productVariantId
            }/${this.friendlyUrl(item.productVariantName)}`}
          >
            <img src={item.defaultImageURL.replace(/\_SML/, '_BIG')} alt={''} />
          </NavLink>
          {this.renderControllerButtons(
            this.state.currentGlamclub,
            products,
            'currentGlamclub'
          )}
          <NavLink
            to={`/produtos/${item.productId}/${
              item.productVariantId
            }/${this.friendlyUrl(item.productVariantName)}`}
            className={'link'}
          >
            Trocar agora
          </NavLink>
        </div>
      );
    });
  };

  renderWinGlampoints = () => {
    const Glampoints = hashTagCampaigns.brands;

    return Glampoints.map((item, key) => {
      return (
        <div
          key={key}
          className={
            this.state.currentWinGlampoints === key ? 'active' : 'noActive'
          }
        >
          <p>{item.hashtag}</p>
          <NavLink to={'ganhe-mais-glampoints'}>
            <img src={item.imagem[0]} alt={''} />
          </NavLink>
          {this.renderControllerButtons(
            this.state.currentWinGlampoints,
            Glampoints,
            'currentWinGlampoints'
          )}
        </div>
      );
    });
  };

  renderCommunity = () => {
    const Community = homeItens[0].community;

    return Community.map((item, key) => {
      return (
        <>
          <div
            key={key}
            className={
              this.state.currentCommunity === key ? 'active' : 'noActive'
            }
          >
            <a href={item.link} target={'_blank'}>
              <img src={item.post} alt={''} />
            </a>
            {this.renderControllerButtons(
              this.state.currentCommunity,
              Community,
              'currentCommunity'
            )}
            <a href={item.link} target={'_blank'} className={'link'}>
              {item.label}
            </a>
          </div>
        </>
      );
    });
  };

  renderTotalGlampoints = () => {
    let { person } = this.props;
    let { personStatus } = person.person;
    let { rewardBalance } = person.person;

    if (!person.subs || person.subs.length < 1 || personStatus === 5) {
      rewardBalance = 0;
    } else {
      rewardBalance = this.glampointsReturn(rewardBalance);
    }

    return (
      <div className={'totalGlampoints'}>
        <p>Total de pontos</p>
        <span>{rewardBalance}</span>
      </div>
    );
  };

  renderGlamshop = () => {
    const Glamshop = homeItens[0].glamshop;

    return Glamshop.map((item, key) => {
      return (
        <div
          key={key}
          className={this.state.currentGlamshop === key ? 'active' : 'noActive'}
        >
          <p>{item.name}</p>
          <a href={item.link} target={'_blank'}>
            <img src={item.image} alt={''} />
          </a>
          {this.renderControllerButtons(
            this.state.currentGlamshop,
            Glamshop,
            'currentGlamshop'
          )}
          <a href={item.link} target={'_blank'} className={'link'}>
            Garantir o seu agora
          </a>
        </div>
      );
    });
  };

  renderEducation = () => {
    const Education = cursosOnline[0].courses;

    return Education.map((item, key) => {
      return (
        <div
          key={key}
          className={
            this.state.currentEducation === key ? 'active' : 'noActive'
          }
        >
          <p>{item.title}</p>
          <NavLink to={`/cursos-online/curso/${key}`}>
            <img src={item.image} alt={''} />
          </NavLink>
          {this.renderControllerButtons(
            this.state.currentEducation,
            Education,
            'currentEducation'
          )}
          <NavLink to={`/cursos-online/curso/${key}`} className={'link'}>
            Assistir
          </NavLink>
        </div>
      );
    });
  };

  renderGlamgirls = () => {
    const Glamgirls = homeItens[0].glamgirls;

    return Glamgirls.map((item, key) => {
      return (
        <div
          key={key}
          className={classnames(
            'glamgirl',
            item.yourself ? 'myself' : '',
            this.state.currentGlamgirl === key ? 'active' : 'noActive'
          )}
        >
          <div className={'profile'}>
            <span>{key + 1}º</span>
            <img src={item.image} alt={''} />
          </div>
          <p>{item.name}</p>
          <strong>{item.points} amigas</strong>
          {this.renderControllerButtons(
            this.state.currentGlamgirl,
            Glamgirls,
            'currentGlamgirl'
          )}
        </div>
      );
    });
  };

  renderPrevButtonVideo = str => {
    const nextIndex = this.state.currentVideoGlamTVIndex + str;
    const verify =
      nextIndex < 0 ? this.state.listVideosYoutube.length - 1 : nextIndex;

    this.setState({
      currentVideoGlamTVIndex: verify,
      currentVideoGlamTV:
        this.state.listVideosYoutube[verify].contentDetails.videoId,
    });
  };

  renderNextButtonVideo = str => {
    const nextIndex = this.state.currentVideoGlamTVIndex + str;
    const verify =
      nextIndex === this.state.listVideosYoutube.length ? 0 : nextIndex;

    this.setState({
      currentVideoGlamTVIndex: verify,
      currentVideoGlamTV:
        this.state.listVideosYoutube[verify].contentDetails.videoId,
    });
  };

  render() {
    return (
      <div className={'p-2 p-lg-5 home'}>
        <Helmet>
          <title>Minha Glambox : Home</title>
        </Helmet>

        <h2>
          Bem-Vinda ao <br />
          Universo <span>Glam</span>
        </h2>

        <div className={'home-universo'}>
          <Container>
            <Row>
              <Col>
                <div className={'d-flex d-column level-3 p-4'}>
                  {this.renderEditions()}
                </div>
              </Col>
              <Col>
                <div className={'d-flex level-3 p-4'}>
                  <h3>Seus Glampoints</h3>
                  {this.renderTotalGlampoints()}
                  <div>
                    <NavLink to={'chama-as-amigas'} className={'link'}>
                      Ganhar mais
                    </NavLink>
                    <br />
                    <NavLink to={'produtos'} className={'link'}>
                      Trocar por produtos
                    </NavLink>
                  </div>
                </div>
              </Col>
              <Col>
                <div className={'d-flex level-3 p-4'}>
                  <h3>
                    Destaques
                    <br /> Glamclub
                  </h3>
                  {this.renderGlamclub()}
                </div>
              </Col>
            </Row>

            <Row>
              <Col>
                <div className={'d-flex level-3 p-4'}>
                  <h3>
                    Oferta da
                    <br /> Semana Glamshop
                  </h3>
                  {this.renderGlamshop()}
                </div>
              </Col>
              <Col>
                <div
                  className={'d-flex level-3 p-4 glamtv'}
                  onClick={this.toggleShippingModal}
                  // style={{
                  //   backgroundImage: `url(${this.state.glamTVThumbnail})`,
                  // }}
                >
                  <button title={'Glambox TV no Youtube'}>
                    <h3>Glam TV</h3>
                    <span></span>
                    <img
                      src="https://s3.amazonaws.com/Glambox.Content.MediaObject/MediaFile_18462.png"
                      alt={'Youtube'}
                      className={'channel'}
                    />
                  </button>
                </div>
              </Col>
              <Col>
                <div className={'d-flex level-3 p-4'}>
                  <h3>Comunidade</h3>
                  <p>Acompanhe nossas redes sociais</p>
                  {this.renderCommunity()}
                </div>
              </Col>
            </Row>

            <Row>
              <Col>
                <div className={'d-flex level-3 p-4'}>
                  <h3>
                    Ganhe
                    <br /> Glampoints
                  </h3>
                  {this.renderWinGlampoints()}
                  <NavLink to={'ganhe-mais-glampoints'} className={'link'}>
                    Quero ganhar mais
                  </NavLink>
                </div>
              </Col>

              <Col>
                <div className={'d-flex level-3 p-4'}>
                  <h3>
                    Glamgirls
                    <br /> do mês
                  </h3>
                  <p>As 5 Glamgirls que mais trouxeram amigas!</p>
                  {this.renderGlamgirls()}
                  <NavLink to={'ganhe-mais-glampoints'} className={'link'}>
                    Como ganhar mais Glampoints
                  </NavLink>
                </div>
              </Col>
              <Col>
                <div className={'d-flex level-3 p-4'}>
                  <h3>
                    Educação
                    <br /> Glamgirl
                  </h3>
                  {this.renderEducation()}
                </div>
              </Col>
            </Row>
          </Container>

          <Modal
            visible={this.state.shippingModalVisible}
            onCloseModal={this.toggleShippingModal}
            useDefaultDialog={false}
            id={'modalvdh'}
          >
            <section className="modal-wrapper">
              <div className="upper-container"></div>
              <div className="mid-container">
                <h2>CONFIRA NOSSOS TUTORIAIS,</h2>
                <p>reviews de produtos e muito mais clicando aqui!</p>
                <a
                  href="https://www.youtube.com/watch?v=IAGvbFlX1C8&list=PLLDqrANGYQinFW2E1Mxthdbq6NK3JUtiV"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  ASSISTIR NO YOUTUBE
                  <img
                    src="https://s3.amazonaws.com/Glambox.Content.MediaObject/MediaFile_19633.png"
                    alt="logo youtube"
                  />
                </a>
              </div>
              <div className="lower-container"></div>
            </section>

            {/* <span>
                    Inscreva-se:
                    <YouTubeSubscribe
                      // channelName={channelName}
                      channelid={'UCTTbhj9byYYGmek19EIDFrQ'}
                      theme={'default'}
                      layout={'default'}
                      count={'default'}
                    />
                  </span> */}
          </Modal>

          {/* <Modal
            visible={this.state.shippingModalVisible}
            onCloseModal={this.toggleShippingModal}
            useDefaultDialog={false}
            id={'modalvdh'}
          >
            <div id="video-view" className={'modal-video-home'}>
              <button onClick={() => this.renderPrevButtonVideo(-1)}>
                <svg width="6.678" height="11.012" viewBox="0 0 6.678 11.012">
                  <path
                    d="M14.369,11.011a1.364,1.364,0,0,0,.989-2.3L12.305,5.5l3.05-3.188A1.365,1.365,0,1,0,13.383.421L9.433,4.549a1.365,1.365,0,0,0,0,1.884l3.949,4.154A1.364,1.364,0,0,0,14.369,11.011Z"
                    transform="translate(-9.055 0)"
                    fill={'#fff'}
                  />
                </svg>
              </button>
              <button onClick={() => this.renderNextButtonVideo(1)}>
                <svg width="6.678" height="11.012" viewBox="0 0 6.678 11.012">
                  <path
                    d="M10.419,11.011a1.364,1.364,0,0,1-.989-2.3L12.483,5.5,9.434,2.308A1.365,1.365,0,1,1,11.406.421l3.949,4.128a1.365,1.365,0,0,1,0,1.884l-3.949,4.154A1.364,1.364,0,0,1,10.419,11.011Z"
                    transform="translate(-9.055 0)"
                    fill={'#fff'}
                  />
                </svg>
              </button>
              <div className="video-wrap">
                <div className="video-container">
                  <iframe
                    width="560"
                    height="315"
                    src={`https://www.youtube.com/embed/${this.state.currentVideoGlamTV}`}
                    title={'Videos Glam TV'}
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  ></iframe>
                </div>
                <small>
                  Video {this.state.currentVideoGlamTVIndex + 1} de{' '}
                  {this.state.listVideosYoutube.length}
                  <span>
                    Inscreva-se:
                    <YouTubeSubscribe
                      // channelName={channelName}
                      channelid={'UCTTbhj9byYYGmek19EIDFrQ'}
                      theme={'default'}
                      layout={'default'}
                      count={'default'}
                    />
                  </span>
                </small>
              </div>
            </div>
          </Modal> */}
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  token: state.token.data,
  rewards: state.rewards.data,
  person: state.person.data,
  editions: state.editions.data,
  subscribers: state.subscribers.data,
});

Home = connect(mapStateToProps)(Home);

export { Home };
